export default "__VITE_ASSET__BTNdY_he__"